/**
 * @file 業務共通日付モジュール
 * @namespace ddv2.library
 */

/**
 * @module date
 */

import filter from '@/rahmen/utils/filters'

export default {
  /**
   * 指定の年、月で月初日を表示する
   * @param {String} year 取得年
   * @param {String} month 取得月
   * @returns {String}
   * @example
   * const a = date.getFirstDate(someYear, someMonth)
   */
  getFirstDate: function (year, month) {
    return filter.dateFormatter(new Date(year, Number(month) - 1, 1))
  },
  /**
   * 指定の年、月で月末日を表示する
   * @param {String} year 取得年
   * @param {String} month 取得月
   * @returns {String}
   * @example
   * const b = date.getLastDate(someYear, someMonth)
   */
  getLastDate: function (year, month) {
    return filter.dateFormatter(new Date(year, Number(month), 0))
  },
  /**
   * 現在日時を取得する
   * ※YYYY/MM/DD HH24:MI:SSとしたい場合はgetCurrentDateとgetCurrentTimeを結合
   */
  getCurrentDateTime () {
    var date = new Date()
    const Y = date.getFullYear()
    const M = ('00' + (date.getMonth() + 1)).slice(-2)
    const D = ('00' + date.getDate()).slice(-2)
    const h = ('00' + date.getHours()).slice(-2)
    const m = ('00' + date.getMinutes()).slice(-2)
    const s = ('00' + date.getSeconds()).slice(-2)

    return Y + M + D + h + m + s
  },
  /**
   * 現在月を取得する
   */
  getCurrentMonth () {
    var date = new Date()
    const Y = date.getFullYear()
    const M = ('00' + (date.getMonth() + 1)).slice(-2)

    return Y + '/' + M
  },
  /**
   * 現在日付を取得する
   */
  getCurrentDate () {
    var date = new Date()
    const Y = date.getFullYear()
    const M = ('00' + (date.getMonth() + 1)).slice(-2)
    const D = ('00' + date.getDate()).slice(-2)

    return Y + '/' + M + '/' + D
  },
  /**
   * 現在時刻を取得する
   */
  getCurrentTime () {
    var date = new Date()
    const h = ('00' + date.getHours()).slice(-2)
    const m = ('00' + date.getMinutes()).slice(-2)
    const s = ('00' + date.getSeconds()).slice(-2)

    return h + ':' + m + ':' + s
  },
  /**
   * 任意の日付を取得
   */
  getAnyDate (val) {
    var date = new Date()
    date.setDate(date.getDate() + val)
    const Y = date.getFullYear()
    const M = ('00' + (date.getMonth() + 1)).slice(-2)
    const D = ('00' + date.getDate()).slice(-2)

    return Y + '/' + M + '/' + D
  }
}
